import { IMAGE_DISPLAY_NAME } from './imageConstants';
import { registerElementType } from '../elements/elementRegistry';
import elementConstructor from '../elements/elementConstructor';
import { ElementType } from '../elements/elementTypes';

const objectConstructorFn = (params) => {
    const { content } = params;
    return {
        ...elementConstructor(params),
        elementType: ElementType.IMAGE_TYPE,
        content: {
            image: null,
            ...content,
        },
    };
};

export default (params = {}) =>
    registerElementType({
        elementType: ElementType.IMAGE_TYPE,
        objectConstructorFn,
        displayName: IMAGE_DISPLAY_NAME,
        ...params,
    });
